export default class DtoQualitometerLandmark {
    constructor(obj) {
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.height = obj.height
        this.pressmark = 0
        this.origin = obj.origin
        this.comment = obj.comment
    }
}